import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
/*
 * Base global do app (at-55). Vive aqui porque este é o único ponto que sempre
 * carrega — antes, o layout de 38 telas dependia de `views/associado/pages/associado.css`,
 * que só 3 telas importavam. Vem logo após `index.css` para preservar a ordem
 * relativa que a cascata já tinha.
 */
import './ui/tokens/base.css';
/*
 * CSS legado compartilhado (at-57, C0 da frente C). Área de espera para as regras
 * dos CSS das telas do fluxo de adesão que telas de FORA dele consomem — hoje sem
 * efeito nenhum (os CSS de tela ainda existem e vencem a cascata por vir depois),
 * e é o que impede a migração daquelas telas de derrubar em silêncio o estilo de
 * dezenas de outras. Vem logo após `base.css` de propósito: a posição early no
 * bundle é parte do contrato — ver o cabeçalho do arquivo.
 */
import './ui/tokens/legado-compartilhado.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

axios.defaults.withCredentials = true;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    {/*
      ÚNICO ToastContainer da aplicação (at-19). Telas e componentes só chamam
      toast(); nunca montar outro container. A lib registra os containers num
      Map chaveado por `containerId || 1`, então containers extras sobrescrevem
      e, ao desmontar, apagam o registro — deixando os toasts numa fila que só
      é descarregada quando outro container monta (mensagem some agora e
      reaparece fora de contexto depois). Fica aqui, fora do <App />, para não
      depender dos early returns dele (gate de bootstrap do token).
    */}
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
    />
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={<div>Carregando estado...</div>} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </React.StrictMode>
  </>
);

reportWebVitals();
